import React, { useState } from "react";
import Button from "../../common/components/Button";
import LoadingSpinner from "../../common/components/LoadingSpinner";

const CachePage = ({ loading, cachePage, onAddAll }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [isAdding, setIsAdding] = useState(false);

  if (loading) {
    return (
      <LoadingSpinner
        style={{ margin: "80px auto", position: "relative", top: "unset" }}
      />
    );
  }

  const toggleSelect = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAddAll = async () => {
    if (isAdding) return;

    const idsToAdd = selectedIds.slice();
    if (idsToAdd.length === 0) return;

    try {
      setIsAdding(true);
      await Promise.resolve(onAddAll(idsToAdd));
      setSelectedIds([]);
    } finally {
      setIsAdding(false);
    }
  };
  const disabled = selectedIds.length === 0 || isAdding;

  return (
    <div>
      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <button
          type="button"
          className="button-secondary"
          onClick={handleAddAll}
          disabled={disabled}
          style={{
            opacity: disabled ? 0.5 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          {isAdding ? "Adding..." : "Add All"}
        </button>
      </div>

      <table
        style={{ overflow: "initial", padding: 0 }}
        className="table study cache-page"
      >
        <tbody>
          <tr>
            <th>Select</th>
            <th>Id</th>
            <th style={{ width: "100%" }}>Name</th>
            <th>Original Page</th>
            <th>Cache Page</th>
          </tr>
          {cachePage.map((item, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  style={{
                    width: "18px",
                    height: "18px",
                    appearance: "checkbox",

                    display: "inline-block",
                    visibility: "visible",
                  }}
                  checked={selectedIds.includes(item.id)}
                  onChange={() => toggleSelect(item.id)}
                />
              </td>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.original_source}
                >
                  Original Link
                </a>
              </td>
              <td>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.cached_source}
                >
                  Cached Link
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CachePage;
